/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespDealerDetails_viewer$ref = any;
type PdpRespHeroCarousel_viewer$ref = any;
type PdpRespIconBubblesWrapper_viewer$ref = any;
type PdpRespSeoLinks_viewer$ref = any;
type PdpRespShippingReturns_viewer$ref = any;
type PdpRespSidebarBlurbs_viewer$ref = any;
type PdpRespSidebarButtons_viewer$ref = any;
type PdpRespSidebarContact_viewer$ref = any;
type PdpRespSidebarSellerInfo_viewer$ref = any;
type PdpRespSimilarItemsFooter_viewer$ref = any;
type PdpRespSimilarItemsGridSeller_viewer$ref = any;
type PdpSharedPromoCode_viewer$ref = any;
type SuspectedTradeUserLoader_viewer$ref = any;
export type PdpRespContainer_viewer$ref = any;
export type PdpRespContainer_viewer = {
    readonly isAboutTheMakerEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly disablePdpExitModal: boolean | null;
    readonly " $fragmentRefs": PdpRespSidebarButtons_viewer$ref & PdpRespSidebarBlurbs_viewer$ref & PdpRespShippingReturns_viewer$ref & PdpRespIconBubblesWrapper_viewer$ref & PdpRespSimilarItemsFooter_viewer$ref & PdpRespSimilarItemsGridSeller_viewer$ref & PdpRespHeroCarousel_viewer$ref & PdpRespSeoLinks_viewer$ref & PdpRespDealerDetails_viewer$ref & PdpRespSidebarContact_viewer$ref & PdpRespSidebarSellerInfo_viewer$ref & PdpSharedPromoCode_viewer$ref & SuspectedTradeUserLoader_viewer$ref;
    readonly " $refType": PdpRespContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "fetchPdp",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isAboutTheMakerEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ABOUT_THE_MAKER"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "FAVORITES"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
        },
        {
            "kind": "ScalarField",
            "alias": "disablePdpExitModal",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disablePdpExitModal"
                }
            ],
            "storageKey": "isEnabled(key:\"disablePdpExitModal\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarButtons_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarBlurbs_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespShippingReturns_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespIconBubblesWrapper_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsFooter_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsGridSeller_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchPdp",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PdpRespHeroCarousel_viewer",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSeoLinks_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespDealerDetails_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarContact_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarSellerInfo_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedPromoCode_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SuspectedTradeUserLoader_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '4a00d2c303a4e0265576d6582dbe4498';
export default node;
